/**
 * Created by ren on 07/06/2017.
 */
import uniq from 'lodash/uniq';
import groupBy from 'lodash/groupBy';
import isUndefined from 'lodash/isUndefined';

import * as common from '../apiCommon';
import {
  ACCOUNT,
  SUBSIDIARY,
  LOCATION,
  BOOLEAN,
} from '../../constants/constant_preference_types';


function getSettingValue(settings) {
  const preferenceSettings = settings || [];
  let account = preferenceSettings.find(
    ({ pref_type }) => pref_type === 'account',
  );
  account = !isUndefined(account) ? parseValue(account) : undefined;

  let subsidiary = preferenceSettings.find(
    ({ pref_type }) => pref_type === 'subsidiary',
  );
  subsidiary = !isUndefined(subsidiary) ? parseValue(subsidiary) : undefined;

  let location = preferenceSettings.find(
    ({ pref_type }) => pref_type === 'location',
  );
  location = !isUndefined(location) ? parseValue(location) : undefined;

  if (!isUndefined(location)) {
    return location;
  }

  if (!isUndefined(subsidiary)) {
    return subsidiary;
  }

  if (!isUndefined(account)) {
    return account;
  }
}

function parseValue(preference) {
  const settingType = preference.setting_type || preference.type;
  if (settingType === BOOLEAN) {
    if (preference.value === 'true') {
      return true;
    }

    if (preference.value === 'false') {
      return false;
    }
  }
  return preference.value;
}

const buildObjSettings = (preferences, settingParams) => {
  const preferenceSettings = groupBy(preferences, 'setting');
  const settings = {};

  settingParams.forEach((setting) => {
    const preference = preferenceSettings[setting];
    settings[setting] = getSettingValue(preference);
  });

  return settings;
};

export const getPreferenceValues = async (app, params) => {
  let { settings, subsidiaryId, locationId, accountId } = params;
  settings = uniq(settings);

  let type_ids = [];
  let pref_types = [];

  if (accountId) {
    type_ids.push(accountId);
    pref_types.push(ACCOUNT);
  }

  if (subsidiaryId) {
    type_ids.push(subsidiaryId);
    pref_types.push(SUBSIDIARY);
  }

  if (locationId) {
    type_ids.push(locationId);
    pref_types.push(LOCATION);
  }

  const { data: preferences } = await common.getDocs(app, {
    filters: {
      type_ids,
      settings,
      requested_page: 1,
      rows_per_page: pref_types.length * settings.length,
    },
    list_type: 'preference',
  });

  return await buildObjSettings(preferences, settings);
};

export const buildPreferenceQueryFromItemLocation = (
  itemLocation,
  settings = [],
  tenant,
) => {
  const accountId = (tenant || {}).id;
  return {
    accountId,
    subsidiaryId: itemLocation.subsidiary_id,
    locationId: itemLocation.location_id,
    settings,
  };
};
